import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { NavMenuList } from "./MenuList";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, ListItemIcon, Typography } from "@mui/material";
import Swal from "sweetalert2";
import LOGO from "../../Assets/Images/logo.png";
import LogoutIcon from '@mui/icons-material/Logout';
import MoreVertIcon from '@mui/icons-material/MoreVert';
const drawerWidth = 280;

const Sidebar = (props) => {
  const { element } = props;
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const location = useLocation();
  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure you want to logout?",
      text: "Logging out will end your session and you will be redirected to the login page.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#46adf2",
      cancelButtonColor: "#5b5d5d",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        Swal.fire({
          title: "Logged Out",
          text: "You have been successfully logged out. Redirecting to login page...",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          navigate("/login");
        });
      }
    });
  };
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <Box
      sx={{
        background: "rgba(230, 238, 242, 1)",
        height: "100vh",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pt: 3,
          width: '109px',
          margin: '0 auto'
        }}
      >
        <img
          src={LOGO}
          alt="logo"
          style={{
            height: "100%",
            width: "100%",
          }}
        />
      </Box>
      <Box
        sx={{ width: "100%", height: "calc(100vh - 150px)", overflowY: "auto", paddingTop: "20px" }}
        className="customSidebarList"
      >
        <List sx={{ p: 0, m: 0.3 }}>
          {NavMenuList.map(({ title, path, icon, active }, i) => (
            <ListItem key={i} disablePadding sx={{ m: "0.5rem 0" }}>
              <Link
                style={{
                  color: "black",
                  textDecoration: "none",
                  width: "100%",
                }}
                to={path}
              >

                <ListItemButton
                  sx={{
                    background: location.pathname.includes(path)
                      ? "rgba(8, 85, 127, 1)"
                      : "transparent",
                    padding: '8px 12px',
                    fontFamily:'Outfit',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: "30px",
                      // pl: 0.5
                    }}
                  >
                    {location.pathname.includes(path) ? (
                      active
                    ) : (
                      icon
                    )}{" "}
                  </ListItemIcon>
                  <ListItemText
                    primary={title}
                    sx={{
                      color: location.pathname.includes(path)
                        ? "#ffffff"
                        : "rgba(115, 115, 115, 1)",
                      pl: 0.5,
                      // fontFamily:'Outfit',
                      ".MuiTypography-root": {
                        fontWeight: "500",
                        fontSize: "16px",
                        fontFamily: "Outfit"
                      }
                    }}
                  />
                </ListItemButton>
              </Link>
            </ListItem>
          ))}
        </List>
      </Box>
      {/* {/ Logout Button /} */}
      <Button
        type="button"
        sx={{
          width: "100%",
          background:
            "transparent",
          padding: "8px 12px",
          fontWeight: "500",
          fontSize: "18px",
          color: "#737373",
          textTransform: "capitalize",
          position: "absolute",
          bottom: "0px",
          left: "0px",
          borderRadius: "0px",
          fontFamily: "Outfit",
          "&:hover": {
            background:
              "transparent",
            color: "#737373",
          },

        }}
        onClick={() => handleLogout()}
      >
        <LogoutIcon /> Logout
      </Button>
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          width: "100%",
          height: "50px",
          boxSizing: "border-box",
        }}
      >
      </Box>

      <Divider />
    </Box >
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          display: { sm: "none" },
          background: "rgba(8, 85, 127, 1)",
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MoreVertIcon sx={{fontSize:'32px'}} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

export default Sidebar;
